import React from "react";
import {Money as MoneyComponent} from "../../../common";
import {Money, PortfolioStats} from "../../../../api-client";
import styles from "./PortfolioStatistics.module.scss";
import {useMyMoneyData} from "../../../../hooks/useMyMoneyData";

const statusMapping: Record<string, keyof PortfolioStats> = {
  "В графике": "loanPayment",
  "В просрочке": "overdue",
  "Возвращено": "paid",
  "В дефолте": "bankrupt",
  "Инкассо": "incasso",
  "Списание": "writeOff",
};

export const PortfolioStatistics = () => {
  const {portfolioStats} = useMyMoneyData();
  const rows = Object.entries(statusMapping).map(([status, key]) => {
    const stat = portfolioStats[key] || {
      projectCount: 0,
      investmentSum: new Money(0, "RUB"),
      principalPaid: new Money(0, "RUB"),
      principalRemain: new Money(0, "RUB"),
      income: new Money(0, "RUB"),
    };

    return {
      status,
      projects: stat.projectCount,
      investment: stat.investmentSum,
      returned: stat.principalPaid,
      balance: stat.principalRemain,
      income: stat.income,
    };
  });

  return (
    <div>
      <h3 className={styles.statistics__title}>Статистика портфеля</h3>
      <div className={styles.statistics__table}>
        <div className={styles.statistics__header}>
          <div>Статус инвестиции</div>
          <div>Проектов</div>
          <div>Сумма инвестиции</div>
          <div>Возвращено ОД</div>
          <div>Остаток ОД</div>
          <div>Доход</div>
        </div>
        {rows.map((row, index) => (
          <div className={styles.statistics__row} key={index}>
            <div>{row.status}</div>
            <div>{row.projects}</div>
            <div>{row.investment.amount === 0 ? "—" : <MoneyComponent money={row.investment}/>}</div>
            <div>{row.returned.amount === 0 ? "—" : <MoneyComponent money={row.returned}/>}</div>
            <div>{row.balance.amount === 0 ? "—" : <MoneyComponent money={row.balance}/>}</div>
            <div>{row.income.amount === 0 ? "—" : <MoneyComponent money={row.income}/>}</div>
          </div>
        ))}
      </div>
    </div>
  );
};